import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../dishFullInfoState/dishFullInfoContext';
import Text from 'components/Text/Text';
import MenuTranslationFullInfo from './MenuTranslationFullInfo/MenuTranslationFullInfo';
import style from './TranslationsTab.module.scss';

const TranslationsTab: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<div className={style.container} data-test="TranslationsTab">
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="translationInfoHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<MenuTranslationFullInfo dishForFullInfo={dishForFullInfo} />
			</div>
		</div>
	);
};

export default TranslationsTab;
